import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../theme';
import { FA_SELECTOR } from '../styles/variables';

export const useShipmentDetailPageStyles = createStyles(({ token }) => ({
  shipmentMilestonesCard: {
    '&&&': {
      '> .SimpleCard-Header': {
        position: 'relative',
        WebkitTransform: 'translate3d(0, 0, 0)',
        zIndex: 1,
      },
      '> .SimpleCard-Body': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: `0 ${ThemeSpaces.SPACE_NORM_20}px`,
        position: 'relative',
        paddingTop: ThemeSpaces.SPACE_NORM,
        height: 128,

        '.MilestoneStepper-Descriptions': {
          // There are always two lines in this use-case and correct height is needed for centering to work
          height: '2.6em',
        },
      },
    },
  },
  headerButton: {
    color: token.colorPrimary,
    textTransform: 'uppercase',
    fontFamily: token.fontFamily,
    fontWeight: 500,

    [FA_SELECTOR]: {
      fontSize: 18,
      marginBottom: ThemeSpaces.SPACE_XXS,
    },
  },
}));
